import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}
export function Reveal({
  children,
  delay = 0,
  className
}: RevealProps) {
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.28,
    ease: [0.23, 1, 0.32, 1],
    delay
  }} data-id="element-493" data-mp="yfj80vw3h6a1">
      {children}
    </motion.div>;
}